/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import {
    string, shape,
} from 'prop-types';

// helper function matches (") and replaces with (\")
const mdParser = (answer) => answer?.replace(/"/gi, '\\"');

const PDPSeoSchemaOutOfStock = ({
    name,
    partNumber,
    location,
    brand,
}) => (
    <>
        <Helmet>
            <script type="application/ld+json">
                {`{
                    "@context":"https://schema.org/",
                    "@type":"Product",
                    "name":"${mdParser(name)}",
                    "sku":"${partNumber}",
                    "brand":{
                            "@type":"Brand",
                            "name":"${brand.description}"
                     },
                    "offers":[{
                           "@type":"Offer",
                            "url":"https://www.${brand.domain}.com${location.pathname}",
                            "priceCurrency": "USD",
                            "sku":"${partNumber}",
                            "availability":"https://schema.org/OutOfStock",
                            "seller":{
                                   "@type":"Organization",
                                   "name":"${brand.description}"
                            }
                     }]
                }`}
            </script>
        </Helmet>
    </>
);

PDPSeoSchemaOutOfStock.propTypes = {
    name: string.isRequired,
    partNumber: string.isRequired,
    location: shape({
        pathname: string.isRequired,
    }).isRequired,
    brand: shape({
        domain: 'string',
        identifier: 'string',
        description: 'string',
    }).isRequired,
};
export default PDPSeoSchemaOutOfStock;
